




























































// Vue
import Vue, { PropType } from "vue";
import { mapActions, mapGetters } from "vuex";
// Vuelidate
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
// Models
import { ApplicationModel } from "@/core/api/apiClient";
// Services
import AdminService from "@/views/admin/Admin.service";

export default Vue.extend({
  name: "CreateApplicationDialog",
  props: {
    application: Object as PropType<ApplicationModel>
  },

  data() {
    return {
      dialog: false,

      name: undefined as string | undefined,
      index: undefined as number | undefined
    };
  },

  mixins: [validationMixin],

  validations: {
    name: { required }
  },

  methods: {
    ...mapActions("appMessages", {
      ADD_ERROR_MESSAGE: "ADD_ERROR_MESSAGE",
      ADD_SUCCESS_MESSAGE: "ADD_SUCCESS_MESSAGE"
    }),

    init(): void {
      if (this.application) {
        this.name = this.application.name;
        this.index = this.application.index;
      }
    },

    submit(): void {
      if (!this.name) return;

      const payload = new ApplicationModel({
        applicationId: this.application.applicationId,
        clientId: this.application.clientId,
        name: this.name,
        index: this.index!
      });

      // * Submit to server
      AdminService.updateApplication(this.currentUser.clientId, payload)
        .then(() => {
          this.$emit("refresh-applications");
          this.close();
          this.ADD_SUCCESS_MESSAGE("Application successfully updated.");
        })
        .catch((error) => {
          console.log(error);
          this.ADD_ERROR_MESSAGE("Error updating application. Please try again.");
        });
    },

    close(): void {
      this.name = undefined;

      this.$v.$reset();
      this.dialog = false;
    }
  },

  computed: {
    ...mapGetters({ currentUser: "currentUser" }),

    nameErrors(): string[] {
      const errors: string[] = [];
      if (!this.$v.$dirty) return errors;
      !this.$v.name.required && errors.push("Name is required");
      return errors;
    }
  }
});
